import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandsHelping, faEye, faListCheck, faUsers, faBriefcase, faConciergeBell, faCrown } from '@fortawesome/free-solid-svg-icons';
import './Povify.css'; 

function PovifyHome() {
  const menuItems = [
    {
      to: '/povify/my',
      icon: faListCheck,
      label: 'My POV',
    },
    {
      to: '/povify/team',
      icon: faUsers,
      label: "Team's POV",
    },
    {
      to: '/povify/department',
      icon: faBriefcase,
      label: "Department's POV",
    },
    {
      to: '/povify/public',
      icon: faConciergeBell,
      label: 'Public POV',
    },
    {
      to: '/povify/best',
      icon: faCrown,
      label: 'Best POV',
    },
    {
      to: '/povify/collaborative',
      icon: faHandsHelping,
      label: 'Collaborative POV',
    },
     {
      to: '/povify-about',
      icon: faEye,
      label: 'About Concept of POVify',
    }
  ];

  return (
    <div className='povify-container'>
      <div className="min-h-screen bg-black text-white">
        {/* Header */}
        <header className="px-4 bg-black border-b border-teal-500 sm:px-6 lg:px-8 mb-6">
        <h1 className="text-xl sm:text-2xl font-bold text-teal-500 text-center">
          POVify
        </h1>
         <p className="text-gray-300 text-xs lg:text-sm font-medium text-center">
          Make Your Points Standout!
        </p>
      </header>

      <div className='min-h-[75vh]'>
        <section className="flex justify-center items-center py-4">
          <div className="text-center">
            <div className="text-2xl lg:text-5xl mb-4">👁️</div>
            <p className="text-gray-400 text-sm lg:text-lg">Point of View</p>
          </div>
        </section>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
          {menuItems.map((item, index) => (
            <Link
              key={index}
              to={item.to}
              className="flex items-center justify-center p-4 bg-blue-800 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900 rounded-lg transition-all duration-200 text-white shadow-md hover:shadow-lg no-underline w-full"
              aria-label={item.label}
            >
              <FontAwesomeIcon
                icon={item.icon}
                className="mr-3 text-blue-200 text-lg flex-shrink-0"
                aria-hidden="true"
              />
              <span className="text-sm font-medium sm:text-base text-center flex-1">
                {item.label}
              </span>
            </Link>
          ))}
        </div>
      </div>

      <footer className="bg-black border-t border-gray-700 text-white py-2">
        <div className=" mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm text-yellow-200">
            © 2026 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  </div>
  );
}

export default PovifyHome;